/**
 * Mirror of packing-label-service/constants.js UNIT_DETAILS.
 * Keep in sync when unit sizes or weights change on the backend.
 */
export const LABEL_UNIT_DETAILS = {
  slab: {
    250: {
      label: '250ml Cans',
      quantity: 24,
      weight: 6.6,
    },
    250.4: {
      label: '4-pack of 250ml Cans',
      quantity: 6,
      weight: 6.7,
    },
    '16x.330': {
      label: '330ml Cans',
      quantity: 16,
      weight: 6.2,
    },
    '24x.330': {
      label: '330ml Cans',
      quantity: 24,
      weight: 8.8,
    },
    330.4: {
      label: '4-pack of 330ml Cans',
      quantity: 6,
      weight: 8.9,
    },
    330.6: {
      label: '6-pack of 330ml Cans',
      quantity: 4,
      weight: 8.9,
    },
    330.12: {
      label: '12-pack of 330ml Cans',
      quantity: 2,
      weight: 8.9,
    },
    '330.10': {
      label: '10-pack of 330ml Cans',
      quantity: 3,
      weight: 10.85,
    },
    375: {
      label: '375ml Cans',
      quantity: 24,
      weight: 9.75,
    },
    440.4: {
      label: '4-pack of 440ml Cans',
      quantity: 6,
      weight: 11.5,
    },
    440.12: {
      label: '440ml Cans',
      quantity: 12,
      weight: 5.75,
    },
    '15x.440': {
      label: '440ml Cans',
      quantity: 15,
      weight: 7.2,
    },
    '16x.440': {
      label: '440ml Cans',
      quantity: 16,
      weight: 7.6,
    },
    '24x.440': {
      label: '440ml Cans',
      quantity: 24,
      weight: 11.5,
    },
  },
  case: {
    330: {
      label: '330ml Bottles',
      quantity: 24,
      weight: 13.75,
    },
    330.6: {
      label: '6-pack of 330ml Bottles',
      quantity: 4,
      weight: 13.75,
    },
    375: {
      label: '375ml Bottles',
      quantity: 12,
      weight: 10.1,
    },
    375.6: {
      label: '6-pack of 375ml Bottles',
      quantity: 4,
      weight: 20.1,
    },
    650: {
      label: '650ml Bottles',
      quantity: 12,
      weight: 13,
    },
    750: {
      label: '750ml Bottles',
      quantity: 6,
      weight: 9.6,
    },
    750.12: {
      label: '750ml Bottles (Crushed 12-pack)',
      quantity: 12,
      weight: 18,
    },
  },
  keg: {
    19.5: {
      label: '19.5L Keg',
      quantity: 1,
    },
    20: {
      label: '20L Keg',
      quantity: 1,
    },
    30: {
      label: '30L Keg',
      quantity: 1,
    },
    50: {
      label: '50L Keg',
      quantity: 1,
    },
  },
};

/** Physical label cell sizes derived from A4 sheet layouts in packing-label-service/pdf.js */
export const LABEL_PREVIEW_SIZES_MM = {
  slab: { width: 68.575, height: 102.75 },
  case: { width: 68.575, height: 102.75 },
  keg: { width: 103, height: 34.2875 },
  pallet: { width: 210, height: 297 },
};

export const CERTIFIED_FRESH_LOGO_URL = 'https://firebasestorage.googleapis.com/v0/b/garage-project-matrix.appspot.com/o/hosting%2Fcertified-fresh-logo-16-03-2022.png?alt=media&token=a4fd53b0-2e8e-4a23-b8cc-2c14e6cd3306';

export const GP_LOGO_URL = 'https://firebasestorage.googleapis.com/v0/b/garage-project-matrix.appspot.com/o/hosting%2Flogo.svg?alt=media&token=64223b46-0630-4d67-b86e-49fea8d0f92f';

export const HUAXI_REGISTRATION_NUMBER = 'CNZL23012212140162';
